













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/modals/Modal.vue';
import ModalHeader from '@/components/modals/ModalHeader.vue';
import ModalBody from '@/components/modals/ModalBody.vue';
import { Decklist } from '@/types/decklist';
import { MODAL, DECKLIST } from '@/store/actions';

@Component({
  components: {
    Modal,
    ModalHeader,
    ModalBody,
  },
})
export default class ImportDecklistModal extends Vue {
  private decklistText: string = '';

  get decklist(): Decklist {
    return this.$store.state.decklist.decklist;
  }

  private close() {
    if (this.$store.state.modal.closeNormal) {
      this.$router.go(-1);
    } else {
      this.$router.replace('/');
      this.$store.commit(MODAL.IMPORT_DECKLIST, false);
    }
  }

  private async importList() {
    this.$store.dispatch(DECKLIST.LOAD_FROM_STRING, this.decklistText);
    this.decklistText = '';
    this.close();
  }
}
